module.exports = __webpack_public_path__ + "static/media/repp-brand-small.d048e089.png";